import axiosInstance from '@/utils/https';

interface CareerPayload {
  email_address: string;
  name: string;
  phone_number: string;
  position: string;
  cv_url: string;
  picture_url: string;
  note: string;
}

export const Addcareer = async (payload: CareerPayload) => {
  try {
    const url = `api/v1/careers`;
    const response = await axiosInstance.post(url, payload);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UploadFile = async (file: any) => {
  try {
    const url = 'api/v1/file/upload';
    const res = await axiosInstance.post(url, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};
